const loginAndSignUp = {
  loginTips: "Heeft u al een HitPaw account ? <1>Inloggen</1>",
  loginSuccessTips: "Inloggen gelukt",
  loginErrorTips: "Inloggen mislukt",
  loginAccountOrPasswordErrorTips: "Uw e-mailadres of wachtwoord is onjuist. Probeer het opnieuw.",
  loginAccountNotExitErrorTips: "De e-mail is niet geregistreerd",
  signUpTips: "Nog geen geregistreerde gebruiker?",
  rememberMe: "Onthoud mij",
  forgotPassword: "Wachtwoord vergeten?",
  forgotPasswordTitle: "Wachtwoord vergeten",
  verifyEmailBtn: "Verifieer e-mail",
  resetPasswordTitle: "Wachtwoord opnieuw instellen",
  resetPasswordLabel: "Resetten uw wachtwoord",
  resetPasswordPlaceholder: "Voer een nieuw wachtwoord in",
  resetPasswordSuccessTips: "Wachtwoord succesvol gereset",
  signUpPrivacyTips: "Door u aan te melden, gaat u akkoord met onze <1>Gebruiksvoorwaarden</1> en <3>Privacy Policy</3>",
  loginPrivacyTips: "Door verder te gaan, gaat u akkoord met onze <1>Gebruiksvoorwaarden</1> en  <3>Privacybeleid</3>",
  signUpSuccessTips: "Uw account is succesvol geregistreerd！",
  getCode: "Code ophalen",
  getCodeSuccessTips: "Het is verzonden naar uw mailbox, verifieer het alstublieft",
  verificationSuccessTips: "E-mail adres verificatie geslaagd",
  surveyTitle: "Welkom bij HitPaw Online",
  surveyStep1: "<1>Stap 1</1>/3",
  surveyStep2: "<1>Stap 2</1>/3",
  surveyStep3: "<1>Stap 3</1>/3",
  surveyQuestion: "Wat is uw doel om HitPaw te gebruiken?",
  surveyThemeQuestion: "Kies de modus die u wilt",
  surveyAnswerOther: "Overige",
  surveyAnswer1: "Levensstijl video",
  surveyAnswer2: "Bedrijfs Video",
  surveyAnswer3: "Bedrijfs Video",
  surveyAnswer4: "Marketing video",
  surveyAnswer5: "Sociale media video",
  surveyAnswer6: "Diavoorstelling video",
  surveyAnswer7: "Video gereedschap",
  surveyAnswer8: "Reis video",
  surveyAnswer9: "Bruiloft video",
  surveyAnswer10: "Verjaardag",
  surveyAnswer11: "Baby Video",
  surveyAnswer12: "Dieren Video",
  surveyAnswer13: "Voedsel video",
  surveyAnswer14: "Mode Video",
  surveyAnswer15: "Vakantie Video",
  surveyAnswer16: "Sport Video",
  surveyAnswer17: "Fotografie Video",
  surveyAnswer18: "Muziek Video",
  surveyAnswerLightMode: "Lichte modus",
  surveyAnswerDarkMode: "Donkere modus",
  surveyNextBtn: "Volgende",
  surveyBackBtn: "Terug",
  surveyDoneBtn: "Gedaan",
  surveyStartBtn: "Aan de slag",
  logoutWarnTips: "Weet u zeker dat u wilt uitloggen?",
};

export default loginAndSignUp;
